import React, { FunctionComponent, ReactNode, CSSProperties } from "react";
import styles from "./StatKpi.module.scss";

type Align = "left" | "center" | "right";
type Size = "sm" | "md" | "lg";

type StatKpiProps = {
  title: ReactNode;
  description?: ReactNode;
  value?: ReactNode; // alias for description
  subtitle?: ReactNode;
  align?: Align;
  size?: Size;
  bordered?: boolean;
  valueColor?: string;
  className?: string;
  variant?: "contained" | "outlined" | "default";
};

const StatKpi: FunctionComponent<StatKpiProps> = ({
  title,
  description,
  value,
  subtitle,
  align = "left",
  size = "md",
  bordered = true,
  valueColor,
  className,
  variant = "default",
}) => {
  const wrapperClassName = [
    styles.wrapper,
    bordered ? styles.bordered : styles.borderless,
    align === "center" ? styles.alignCenter : align === "right" ? styles.alignRight : styles.alignLeft,
    size === "sm" ? styles.sizeSm : size === "lg" ? styles.sizeLg : styles.sizeMd,
    variant === "contained" ? styles.contained : variant === "outlined" ? styles.outlined : undefined,
    className,
  ]
    .filter(Boolean)
    .join(" ");

  const valueStyle: CSSProperties | undefined = valueColor
    ? { color: valueColor }
    : undefined;

  const displayValue = description !== undefined ? description : value;

  return (
    <div className={wrapperClassName}>
      <div className={styles.content}>
        <div className={styles.title}>{title}</div>
        {displayValue !== undefined && (
          <div className={styles.value} style={valueStyle}>
            {displayValue}
          </div>
        )}
        {subtitle && <div className={styles.subtitle}>{subtitle}</div>}
      </div>
    </div>
  );
};

export default StatKpi;


